<template>
  <div class="department-wrap style8 pb-100">
    <div class="container">
      <div class="row gx-5 align-items-center">
        <div class="col-lg-6">
          <div class="dp-content">
            <div class="content-title style1">
              <span>Our Department</span>
              <h2>
                We Take Care Of You &amp; Your Family's Health &amp; Well-Being
              </h2>
              <p>
                It is a long established fact that a reader will be distracted
                by the readable content when looking at its layout. The point of
                using Lorem Ipsum is that amet has a moreorless normal
                distribution of letters as opposed dolor.
              </p>
            </div>
            <ul class="content-feature-list list-style">
              <li>
                <i class="ri-check-double-line"></i>Search for innovation in
                dentristy
              </li>
              <li>
                <i class="ri-check-double-line"></i>24/7 personal customer
                relationship manager
              </li>
              <li>
                <i class="ri-check-double-line"></i>Lifetime warrenties on all
                treatment services
              </li>
              <li>
                <i class="ri-check-double-line"></i>Advanced laser setup &amp;
                technology
              </li>
            </ul>

            <div class="feature-item-wrap">
              <div class="feature-item">
                <div class="feature-icon">
                  <i class="flaticon-laser"></i>
                </div>
                <div class="feature-text">
                  <h5>25 Years</h5>
                  <p>Of Experience</p>
                </div>
              </div>
              <div class="feature-item">
                <div class="feature-icon">
                  <i class="flaticon-pain-in-joints"></i>
                </div>
                <div class="feature-text">
                  <h5>645+</h5>
                  <p>Orthopedic Services</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6">
          <div class="dp-img-wrap dp-bg-2 bg-f">
            <div class="dp-promo-box">
              <span>Orthopedic Department</span>
              <h5>
                Includes General Orthopedic Related Diagnosis Based On Body
                Parts
              </h5>
              <p>
                Lorem ipsum dolor sit amet consec tetur adicing elit. Facere
                totam tempore, distinctio dolor emque excepturi saepe eligendi
                iure fugiat.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OurDepartment",
};
</script>